export const sanitizeZipCodeValue = (value: string) =>
  value && value.length >= 1 && value[value.length - 1] === '-'
    ? value.substring(0, 2)
    : value;
